export const RED = "red";
export const BLUE = "blue";
export const GREEN = "green";
export const PURPLE = "purple";
